import PropTypes from "prop-types";
import CardLabel from "./CardLabel";

const StatTable = ({ data = [] }) => (
  <table className="tw-grow">
    <thead>
      <tr>
        {data.map(({ label }) => (
          <th>
            <div className="tw-text-14d tw-font-bold">{label}</div>
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      <tr className="tw-bg-gray-5">
        {data.map(({ units }) => (
          <td className="tw-p-[4px]">
            <CardLabel
              className="tw-flex-col"
              label={units?.label}
              value={units?.value}
              valueColor={units?.color}
            />
          </td>
        ))}
      </tr>
      <tr>
        {data.map(({ volume }) => (
          <td className="tw-p-[4px]">
            <CardLabel
              className="tw-flex-col"
              label={volume?.label}
              value={volume?.value}
              valueColor={volume?.color}
            />
          </td>
        ))}
      </tr>
      <tr className="tw-bg-gray-5">
        {data.map(({ gci }) => (
          <td className="tw-p-[4px]">
            <CardLabel
              className="tw-flex-col"
              label={gci?.label}
              value={gci?.value}
              valueColor={gci?.color}
            />
          </td>
        ))}
      </tr>
      <tr>
        {data.map(({ avgSalePrice }) => (
          <td className="tw-p-[4px]">
            <CardLabel
              className="tw-flex-col"
              label={avgSalePrice?.label}
              value={avgSalePrice?.value}
              valueColor={avgSalePrice?.color}
            />
          </td>
        ))}
      </tr>
    </tbody>
  </table>
);

StatTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      units: PropTypes.number,
      volume: PropTypes.string,
      gci: PropTypes.string,
      avgSalePrice: PropTypes.string,
    }),
  ).isRequired,
};

export default StatTable;
